import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Behfa_Interface } from 'src/app/Interface/Behfa_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BehfaService {

  constructor(private http:HttpClient) { }

  GetRecord(Token:String):Observable<Array<Behfa_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Behfa?token="+Token).pipe(
      map(data=>{
        return data as Array<Behfa_Interface>
      })
    )
  }

  GetSingle(Token:String,id:number):Observable<Behfa_Interface>{
    return this.http.get(environment.BaseUrl + "Daro/Behfa/GetSingle?token="+Token+"&id="+id).pipe(
      map(data=>{
        return data as Behfa_Interface
      })
    )
  }

  AddEditBehfa(model: Behfa_Interface,Token:String):Observable<Behfa_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body={
      id:model.id,
      val:model.val+'',
      type:model.type,
      create_user:Token
    }

    return this.http.post(environment.BaseUrl + "Daro/Behfa/AddEdit",body,{headers}).pipe(
      map(data=>{
        return data as Behfa_Interface
      })
    )
  }

  DeleteBehfa(id:number,Token:String):Observable<Behfa_Interface>{

    return this.http.get(environment.BaseUrl + "Daro/Behfa/Delete?id="+id+"&token="+Token).pipe(
      map(data=>{
        return data as Behfa_Interface
      })
    )
  }

  PriorityBehfa(id:number,Token:String):Observable<Behfa_Interface>{

    return this.http.get(environment.BaseUrl + "Daro/Behfa/Priority?id="+id+"&token="+Token).pipe(
      map(data=>{
        return data as Behfa_Interface
      })
    )
  }

  uploadFile(body,Token:String){

    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/Behfa/Upload?token="+Token,body).pipe(
      map(data=>{

        return data
      })
    )
  }


}
